import { ImageIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React from 'react'

interface PhotoReelButtonProps {
  onToggle: () => void
  isOpen: boolean
}

export const PhotoReelButton: React.FC<PhotoReelButtonProps> = ({
  onToggle,
  isOpen,
}) => {
  return (
    <TooltipWrapper side={'right'} offset={5} label={'Photo Reel'}>
      <ViewToggle
        onClick={(selected, setSelected) => {
          setSelected(!isOpen)
          onToggle()
        }}>
        <ImageIcon width={22} height={22} />
      </ViewToggle>
    </TooltipWrapper>
  )
}
